import parseDialogue from "../../util/parseDialogue";

export const JoanaC5 = parseDialogue(`
joana:c5:100-400

#100 Agent. I can see you're about to enter our sysadmin archives. Thank you for handling this mission. I wanted to give you some advice.
>200 Go ahead.

#200 If you are successful, we will reward you with a copy of some new software that we just developed. I'm told that's the proper way to motivate people such as yourself.
>300 Thanks... I guess.

#300 Good luck, agent.
>400 Over and out.
`);
